import React, { memo } from "react";
import { Voucher } from "../../types";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import { GolTooltip } from "../tooltip/tooltip";

interface ICommercialsSummaryItem {
  voucher: Voucher;
  onRemoveVoucher?: (value: string) => void;
  isRemovable?: Boolean;
}

const VoucherWrapper = styled.div`
  display: inline-flex;
  width: fit-content;
  align-items: center;
  border-radius: 4px;
  background-color: ${(props) => props.theme.voucherBackgroundColor};
  color: ${(props) => props.theme.voucherTextColor};
  padding: 4px 8px 4px 12px;
  margin: 4px 0 4px;
`;

const VoucherName = styled.div`
  font-size: 14px;
`;

const CustomGolTooltip = styled.div`
  margin-left: 24px;
`;

const VoucherRemove = styled(CloseIcon)`
  color: ${(props) => props.theme.voucherTextColor};
  font-size: 24px !important;
  margin-left: 12px;
  cursor: pointer;
`;

const Item = (props: ICommercialsSummaryItem) => {
  const voucher = props.voucher;

  const onRemoveVoucher = () => {
    props.onRemoveVoucher!(voucher.code);
  };

  return (
    <VoucherWrapper data-test="voucher-item-wrapper">
      <VoucherName>{voucher.code}</VoucherName>
      <CustomGolTooltip>
        <GolTooltip title={voucher.name} text={voucher.description} />
      </CustomGolTooltip>
      {props.isRemovable && <VoucherRemove data-test="voucher-remove" onClick={onRemoveVoucher} />}
    </VoucherWrapper>
  );
};

export const VoucherItem = memo(Item);
